module.exports = __webpack_public_path__ + "static/media/ic_proyectos_borders_pin_seleccionado.aa89e1d0.svg";